var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["columnSize", "xs", "sm", "md", "spacing", "elements"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, CircularProgress, Grid, Icon, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { memo, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { deleteState, setReducerState } from "../../../../redux/crudSlice";
import { useAppSelector } from "../../../../store/hooks";
import { generateDynamicFormFields } from "../../../common/commonFunctions";
import { ValidationTypes } from "../../regex/validations";
import { FormAttachment } from "../components/formAttachment";
import FormButton from "../components/formButton";
import { FormCheckbox } from "../components/formCheckbox";
import { FormDatePicker } from "../components/formDatePicker";
import { FormDateRangePicker } from "../components/formDateRangePicker";
import { FormDateTimePicker } from "../components/formDateTimePicker";
import FormIconButton from "../components/formIconButton";
import { FormSearchSelect } from "../components/formSearchSelect";
import { FormSingleSelect } from "../components/formSingleSelect";
import { FormTextInput } from "../components/formTextInput";
import { FormTimePicker } from "../components/formTimePicker";
import { FormAccordion } from "../surfaces/formAccordion";
import FormAvatar from "../surfaces/formAvatar";
import FormCard from "../surfaces/formCard";
import FormChip from "../surfaces/formChip";
import FormDivider from "../surfaces/formDivider";
import FormIcon from "../surfaces/formIcon";
import FormList from "../surfaces/formList";
import { FormMobileStepper } from "../surfaces/formMobileStepper";
import FormTabs from "../surfaces/formTabs";
import { ElementsWithFormLoop, ElementsWithoutChangeEvent, FormItemTypes, NoLabelElementsTypes } from "./dynamicFormBuilder.entity";
import { useDynamicForm } from "./useDynamicForm";
import FormIterator from "../surfaces/formIterator";
import useRbacController from "../../../rbac/useRbacController";
import FormErrorsPanel from "../surfaces/formErrorsPanel";
export var DynamicFormBuilderContainer = function (props) {
    var _mode;
    var _a = props.createKey, createKey = _a === void 0 ? '_create' : _a, createRequest = props.createRequest, createFormAPI = props.createFormAPI, _b = props.updateKey, updateKey = _b === void 0 ? '_update' : _b, updateRequest = props.updateRequest, updateFormAPI = props.updateFormAPI, _c = props.getKey, getKey = _c === void 0 ? '_get' : _c, getRequest = props.getRequest, getFormAPI = props.getFormAPI, _d = props.pagingAPIKey, pagingAPIKey = _d === void 0 ? '' : _d, formData = props.formData, onClose = props.onClose, onSubmit = props.onSubmit, onStateChange = props.onChange, _e = props.gridSpacing, gridSpacing = _e === void 0 ? 2 : _e, _f = props.formProps, formProps = _f === void 0 ? {} : _f, gridProps = props.gridProps, errorsFromProps = props.errors, rbacRoute = props.rbacRoute, state = props.state, _g = props.updateFromSubmitResponse, updateFromSubmitResponse = _g === void 0 ? false : _g;
    var _h = props.mode, mode = _h === void 0 ? 'add' : _h;
    var crud = useAppSelector(function (state) { return state.crud; });
    var createLoader = crud['isLoading' + createKey];
    var updateLoader = crud['isLoading' + updateKey];
    var getLoader = crud['isLoading' + getKey];
    var pagingUpdateKey = pagingAPIKey + 'Updated';
    var searchParams = useSearchParams()[0];
    mode = (_mode = mode) !== null && _mode !== void 0 ? _mode : searchParams.get('mode');
    var dispatch = useDispatch();
    var formApi = useDynamicForm(formData, true, mode, onStateChange, state);
    var values = formApi.values, setValues = formApi.setValues, errors = formApi.errors, setErrors = formApi.setErrors, handleOptionChange = formApi.handleOptionChange, handleInputChange = formApi.handleInputChange, handleServerSideErrors = formApi.handleServerSideErrors, formValidate = formApi.formValidate, handleAttachmentChange = formApi.handleAttachmentChange, resetForm = formApi.resetForm, handleButtonClick = formApi.handleButtonClick, disabled = formApi.disabled, attachmentUploader = formApi.attachmentUploader;
    var rbac = useRbacController(rbacRoute);
    useEffect(function () {
        // setErrors((prev) => ({ ...prev, ...errorsFromProps, id: '' }))
        setErrors(function (prev) { return _objectSpread(_objectSpread({}, errorsFromProps), {}, {
            id: ''
        }); });
    }, [errorsFromProps === null || errorsFromProps === void 0 ? void 0 : errorsFromProps.id]);
    useEffect(function () {
        if (mode !== 'add') {
            getData();
        }
    }, [mode]);
    useEffect(function () {
        return function () {
            dispatch(deleteState({
                key: createKey
            }));
            dispatch(deleteState({
                key: updateKey
            }));
            dispatch(deleteState({
                key: getKey
            }));
        };
    }, []);
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _resp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resp = {};
                    if (!!getFormAPI) return [3 /*break*/, 1];
                    resp = crud[getKey];
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getFormAPI({
                        key: getKey || undefined,
                        request: _objectSpread({}, getRequest)
                    })];
                case 2:
                    resp = _a.sent();
                    _a.label = 3;
                case 3:
                    if ((_resp = resp) !== null && _resp !== void 0 && _resp.success) {
                        setValues(function (prev) {
                            var _resp2;
                            return _objectSpread(_objectSpread({}, prev), (_resp2 = resp) === null || _resp2 === void 0 ? void 0 : _resp2.data);
                        });
                    }
                    else {
                        handleServerSideErrors(resp);
                    }
                    return [2 /*return*/, resp];
            }
        });
    }); };
    var handleSubmit = function (e) {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function () {
            var newValues, fields, _res, attachmentFields_1, attachmentRequest, res_1, request, request, _res3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newValues = arguments_1.length > 1 && arguments_1[1] !== undefined ? arguments_1[1] : {};
                        e.preventDefault();
                        e.stopPropagation();
                        fields = generateDynamicFormFields(formData);
                        return [4 /*yield*/, formValidate(values, fields)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 8];
                        newValues = _objectSpread(_objectSpread({}, values), newValues);
                        attachmentFields_1 = [];
                        fields === null || fields === void 0 || fields.forEach(function (it) {
                            if (!it)
                                return;
                            if (it.validation === ValidationTypes.number) {
                                newValues[it.name] = parseInt(values[it.name]);
                            }
                            if (it.validation === ValidationTypes.decimalNumber) {
                                newValues[it.name] = Number(values[it.name]);
                            }
                            if (it.type === FormItemTypes.NumberInput) {
                                newValues[it.name] = Number(values[it.name]);
                            }
                            if (it.type === FormItemTypes.CheckBox) {
                                newValues[it.name] = Boolean(values[it.name]);
                            }
                            if (it.type === FormItemTypes.Attachment) {
                                attachmentFields_1.push(it);
                            }
                        });
                        attachmentRequest = {};
                        if (!(attachmentFields_1 !== null && attachmentFields_1 !== void 0 && attachmentFields_1.length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, attachmentUploader(attachmentFields_1)];
                    case 2:
                        attachmentRequest = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(mode === 'add')) return [3 /*break*/, 5];
                        request = _objectSpread(_objectSpread(_objectSpread({}, newValues), createRequest), attachmentRequest);
                        return [4 /*yield*/, (createFormAPI === null || createFormAPI === void 0 ? void 0 : createFormAPI({
                                key: createKey,
                                request: request
                            }))];
                    case 4:
                        res_1 = _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        request = _objectSpread(_objectSpread(_objectSpread({}, newValues), updateRequest), attachmentRequest);
                        return [4 /*yield*/, (updateFormAPI === null || updateFormAPI === void 0 ? void 0 : updateFormAPI({
                                key: updateKey,
                                request: request
                            }))];
                    case 6:
                        res_1 = _a.sent();
                        _a.label = 7;
                    case 7:
                        onSubmit === null || onSubmit === void 0 || onSubmit(newValues);
                        if ((_res = res_1) !== null && _res !== void 0 && _res.success) {
                            onCancel(e, true);
                            if (updateFromSubmitResponse)
                                setValues(function (prev) {
                                    var _res2;
                                    return _objectSpread(_objectSpread({}, prev), (_res2 = res_1) === null || _res2 === void 0 ? void 0 : _res2.data);
                                });
                        }
                        else {
                            handleServerSideErrors((_res3 = res_1) === null || _res3 === void 0 ? void 0 : _res3.data);
                        }
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    var onCancel = function (e, isUpdated) {
        var _e$preventDefault;
        e === null || e === void 0 || (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 || _e$preventDefault.call(e);
        if (isUpdated)
            dispatch(setReducerState({
                key: pagingUpdateKey,
                value: isUpdated
            }));
        onClose === null || onClose === void 0 || onClose(e, isUpdated);
    };
    var handleActions = useCallback(function (e, type, currentRequest) {
        switch (type) {
            case 'submit':
                handleSubmit(e, currentRequest);
                break;
            case 'reset':
                resetForm(e);
                break;
            default:
                break;
        }
    }, [mode, values]);
    var getOnChange = useCallback(function (el) {
        return function (event, value) {
            var arguments_2 = arguments;
            return __awaiter(this, void 0, void 0, function () {
                var _el$onChange, _len, args, _key;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            event === null || event === void 0 || event.stopPropagation();
                            if (!(el.type === FormItemTypes.SearchSelect || el.type === FormItemTypes.SingleSelect)) return [3 /*break*/, 2];
                            return [4 /*yield*/, handleOptionChange(event, value, el)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 6];
                        case 2:
                            if (!(el.type === FormItemTypes.Attachment)) return [3 /*break*/, 4];
                            return [4 /*yield*/, handleAttachmentChange(event, value, el)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 6];
                        case 4: return [4 /*yield*/, handleInputChange(event, value, el)];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6:
                            for (_len = arguments_2.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                                args[_key - 2] = arguments_2[_key];
                            }
                            return [4 /*yield*/, (el === null || el === void 0 || (_el$onChange = el.onChange) === null || _el$onChange === void 0 ? void 0 : _el$onChange.call.apply(_el$onChange, __spreadArray([el, event, value], args, false)))];
                        case 7:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
    }, [values, onStateChange, handleInputChange, handleOptionChange, handleAttachmentChange]);
    return /*#__PURE__*/ React.createElement(Box, formProps, getLoader !== "loading" ? /*#__PURE__*/ React.createElement(Grid, _extends({
        container: true,
        spacing: gridSpacing
    }, gridProps), formData === null || formData === void 0 ? void 0 : formData.map(function formLoop(el) {
        var _this = this;
        var _el$elements$0$name, _el$elements$, _el$elements$1$name, _el$elements$2, _ref, _el$valueGetter, _el$valueGetter2, _el$id, _el$elements$0$name2, _el$elements$3, _el$elements$1$name2, _el$elements$4, _el$error, _elementProps$name, _el$setFieldProps, _elementProps;
        if (!el || el.hidden)
            return null;
        var columnSize = el.columnSize, _a = el.xs, xs = _a === void 0 ? columnSize !== null && columnSize !== void 0 ? columnSize : 12 : _a, _b = el.sm, sm = _b === void 0 ? columnSize !== null && columnSize !== void 0 ? columnSize : 6 : _b, _c = el.md, md = _c === void 0 ? columnSize !== null && columnSize !== void 0 ? columnSize : 3 : _c;
        var currFieldValue;
        if (el.type !== FormItemTypes.DateRangePicker)
            currFieldValue = values[el.name];
        else
            currFieldValue = (el === null || el === void 0 ? void 0 : el.elements) && [values[(_el$elements$0$name = (_el$elements$ = el.elements[0]) === null || _el$elements$ === void 0 ? void 0 : _el$elements$.name) !== null && _el$elements$0$name !== void 0 ? _el$elements$0$name : ''], values[(_el$elements$1$name = (_el$elements$2 = el.elements[1]) === null || _el$elements$2 === void 0 ? void 0 : _el$elements$2.name) !== null && _el$elements$1$name !== void 0 ? _el$elements$1$name : '']];
        currFieldValue = (_ref = (_el$valueGetter = (_el$valueGetter2 = el.valueGetter) === null || _el$valueGetter2 === void 0 ? void 0 : _el$valueGetter2.call(el, values, el)) !== null && _el$valueGetter !== void 0 ? _el$valueGetter : currFieldValue) !== null && _ref !== void 0 ? _ref : el.value;
        var elementProps = _objectSpread(_objectSpread({}, el), {}, {
            id: (_el$id = el.id) !== null && _el$id !== void 0 ? _el$id : el.name,
            value: currFieldValue,
            error: el.type === FormItemTypes.DateRangePicker && el.elements ? [errors[(_el$elements$0$name2 = (_el$elements$3 = el.elements[0]) === null || _el$elements$3 === void 0 ? void 0 : _el$elements$3.name) !== null && _el$elements$0$name2 !== void 0 ? _el$elements$0$name2 : ''], errors[(_el$elements$1$name2 = (_el$elements$4 = el.elements[1]) === null || _el$elements$4 === void 0 ? void 0 : _el$elements$4.name) !== null && _el$elements$1$name2 !== void 0 ? _el$elements$1$name2 : '']] : (_el$error = el.error) !== null && _el$error !== void 0 ? _el$error : errors[el.name],
            disabled: el.disabled || mode !== 'add' && disabled || updateLoader === "loading" || createLoader === "loading"
        });
        if (!ElementsWithoutChangeEvent.includes(elementProps.type)) {
            elementProps.onChange = getOnChange(el);
        }
        if (ElementsWithFormLoop.includes(elementProps.type)) {
            elementProps.formLoop = formLoop;
        }
        if (!ElementsWithoutChangeEvent.includes(elementProps.type)) {
            elementProps.onChange = getOnChange(el);
        }
        if (elementProps.type === FormItemTypes.TextInput && el.type === FormItemTypes.TextInput && el.onBlur) {
            elementProps.onBlur = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var _el$onBlur;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ((_el$onBlur = el.onBlur) === null || _el$onBlur === void 0 ? void 0 : _el$onBlur.call(el, e, values, formApi))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        if (elementProps.type === FormItemTypes.NumberInput && el.type === FormItemTypes.NumberInput && el.onBlur) {
            elementProps.onBlur = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var _el$onBlur2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ((_el$onBlur2 = el.onBlur) === null || _el$onBlur2 === void 0 ? void 0 : _el$onBlur2.call(el, e, values, formApi))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        if (elementProps.type === FormItemTypes.MobileStepper && el.type === FormItemTypes.MobileStepper) {
            elementProps.getActiveStepElements = function (step, currElements) {
                var _el$getActiveStepElem, _el$getActiveStepElem2;
                return (_el$getActiveStepElem = (_el$getActiveStepElem2 = el.getActiveStepElements) === null || _el$getActiveStepElem2 === void 0 ? void 0 : _el$getActiveStepElem2.call(el, step, currElements, values)) !== null && _el$getActiveStepElem !== void 0 ? _el$getActiveStepElem : currElements;
            };
            elementProps.onStepChange = function (e, step, data) {
                var _el$onStepChange;
                handleInputChange(e, "".concat(step), elementProps);
                (_el$onStepChange = el.onStepChange) === null || _el$onStepChange === void 0 || _el$onStepChange.call(el, e, step, _objectSpread(_objectSpread({}, data), values));
            };
        }
        if (elementProps.type === FormItemTypes.Tabs && el.type === FormItemTypes.Tabs) {
            // elementProps.getActiveTabElements = (currTab) => el.getActiveTabElements?.(currTab, values) ?? currTab;
            elementProps.errors = errors;
        }
        if (elementProps.type === FormItemTypes.ErrorsPanel && el.type === FormItemTypes.ErrorsPanel) {
            var _el$elements;
            elementProps.errors = errors;
            elementProps.elements = (_el$elements = el.elements) !== null && _el$elements !== void 0 ? _el$elements : formData;
        }
        if (el.type === FormItemTypes.Custom && elementProps.type === FormItemTypes.Custom) {
            elementProps.value = values;
            elementProps.error = errors;
            // elementProps.element = (elementProps) => el.element?.(elementProps)
        }
        if (elementProps.type === FormItemTypes.Button && el.type === FormItemTypes.Button) {
            elementProps.onClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var _el$onClick, action, currentUpdates;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ((_el$onClick = el.onClick) === null || _el$onClick === void 0 ? void 0 : _el$onClick.call(el, e, values, formApi))];
                        case 1:
                            action = _a.sent();
                            if (el.unsubscribeFormChange)
                                return [2 /*return*/];
                            return [4 /*yield*/, handleButtonClick(e, el)];
                        case 2:
                            currentUpdates = _a.sent();
                            if (action)
                                handleActions(e, action, currentUpdates);
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        if (elementProps.type === FormItemTypes.IconButton && el.type === FormItemTypes.IconButton) {
            elementProps.onClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var _el$onClick2, action, currentUpdates;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ((_el$onClick2 = el.onClick) === null || _el$onClick2 === void 0 ? void 0 : _el$onClick2.call(el, e, values, formApi))];
                        case 1:
                            action = _a.sent();
                            if (el.unsubscribeFormChange)
                                return [2 /*return*/];
                            return [4 /*yield*/, handleButtonClick(e, el)];
                        case 2:
                            currentUpdates = _a.sent();
                            if (action)
                                handleActions(e, action, currentUpdates);
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        if (elementProps.type === FormItemTypes.SearchSelect && el.type === FormItemTypes.SearchSelect) {
            elementProps.state = values;
        }
        if (elementProps.type === FormItemTypes.List && el.type === FormItemTypes.List) {
            elementProps.getListData = function (params) { return __awaiter(_this, void 0, void 0, function () {
                var _await$el$getListData, _el$getListData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            params.state = values;
                            return [4 /*yield*/, ((_el$getListData = el.getListData) === null || _el$getListData === void 0 ? void 0 : _el$getListData.call(el, params))];
                        case 1: return [2 /*return*/, (_await$el$getListData = _a.sent()) !== null && _await$el$getListData !== void 0 ? _await$el$getListData : {}];
                    }
                });
            }); };
        }
        if (elementProps.type === FormItemTypes.Iterator && el.type === FormItemTypes.Iterator) {
            elementProps.getOnChange = getOnChange;
        }
        if (elementProps.type === FormItemTypes.Attachment && el.type === FormItemTypes.Attachment) {
            elementProps.deleteAttachmentAPI = function (params) { return __awaiter(_this, void 0, void 0, function () {
                var _await$el$deleteAttac, _el$deleteAttachmentA;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            params.state = values;
                            return [4 /*yield*/, ((_el$deleteAttachmentA = el.deleteAttachmentAPI) === null || _el$deleteAttachmentA === void 0 ? void 0 : _el$deleteAttachmentA.call(el, params))];
                        case 1: return [2 /*return*/, (_await$el$deleteAttac = _a.sent()) !== null && _await$el$deleteAttac !== void 0 ? _await$el$deleteAttac : {}];
                    }
                });
            }); };
            elementProps.downloadAttachmentAPI = function (params) { return __awaiter(_this, void 0, void 0, function () {
                var _await$el$downloadAtt, _el$downloadAttachmen;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            params.state = values;
                            return [4 /*yield*/, ((_el$downloadAttachmen = el.downloadAttachmentAPI) === null || _el$downloadAttachmen === void 0 ? void 0 : _el$downloadAttachmen.call(el, params))];
                        case 1: return [2 /*return*/, (_await$el$downloadAtt = _a.sent()) !== null && _await$el$downloadAtt !== void 0 ? _await$el$downloadAtt : {}];
                    }
                });
            }); };
        }
        var rbacControl = rbac === null || rbac === void 0 ? void 0 : rbac[(_elementProps$name = elementProps.name) !== null && _elementProps$name !== void 0 ? _elementProps$name : ''];
        var overrideProps = (_el$setFieldProps = el.setFieldProps) === null || _el$setFieldProps === void 0 ? void 0 : _el$setFieldProps.call(el, values, currFieldValue, elementProps, formApi);
        elementProps = _objectSpread(_objectSpread(_objectSpread({}, elementProps), overrideProps), rbacControl);
        if (elementProps.hidden)
            return null;
        if (elementProps.disabled && elementProps.required)
            elementProps.required = false;
        var Element = FormElement[elementProps.type];
        if (elementProps.type === FormItemTypes.ContainerItem || elementProps.type === FormItemTypes.Stack || elementProps.type === FormItemTypes.ErrorsPanel) {
            return /*#__PURE__*/ React.createElement(Element, elementProps);
        }
        return /*#__PURE__*/ React.createElement(Grid, _extends({
            item: true,
            xs: xs,
            sm: sm,
            md: md,
            alignSelf: elementProps.type === FormItemTypes.Divider ? 'stretch' : undefined,
            container: elementProps.type === FormItemTypes.Iterator
        }, elementProps.containerProps), !NoLabelElementsTypes.includes(elementProps.type) && ((_elementProps = elementProps) === null || _elementProps === void 0 ? void 0 : _elementProps.label) && /*#__PURE__*/ React.createElement(Typography, _extends({
            fontSize: "sm",
            fontWeight: "medium",
            color: "secondary",
            mb: 0.5
        }, elementProps.labelTypographyProps), typeof elementProps.label === 'string' ? t(elementProps.label) : elementProps.label, elementProps.required ? /*#__PURE__*/ React.createElement(Icon, {
            fontSize: "inherit",
            color: "error"
        }, "*") : null), /*#__PURE__*/ React.createElement(Element, elementProps));
    })) : /*#__PURE__*/ React.createElement(Stack, {
        height: 200,
        maxHeight: "100%",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 40
    })));
};
export var FormElement = (_a = {},
    _a[FormItemTypes.SearchSelect] = FormSearchSelect,
    _a[FormItemTypes.TextInput] = FormTextInput,
    _a[FormItemTypes.NumberInput] = function (el) {
        var _el$InputProps;
        return /*#__PURE__*/ React.createElement(FormTextInput, _extends({}, el, {
            type: "number",
            InputProps: _objectSpread(_objectSpread({}, el.InputProps), {}, {
                sx: _objectSpread({
                    /* Chrome, Safari, Edge, Opera */
                    "&input::-webkit-outer-spin-button,input::-webkit-inner-spin-button": {
                        "-webkit-appearance": "none",
                        margin: 0
                    },
                    /* Firefox */
                    "&input[type=number]": {
                        "-moz-appearance": "textfield"
                    },
                    fontSize: 14
                }, (_el$InputProps = el.InputProps) === null || _el$InputProps === void 0 ? void 0 : _el$InputProps.sx)
            })
        }));
    },
    _a[FormItemTypes.Password] = function (el) { /*#__PURE__*/ return React.createElement(FormTextInput, _extends({}, el, {
        type: "password",
        inputProps: {
            maxLength: el.maxLength,
            min: el.minValue,
            max: el.maxValue
        }
    })); },
    _a[FormItemTypes.CheckBox] = FormCheckbox,
    _a[FormItemTypes.DatePicker] = FormDatePicker,
    _a[FormItemTypes.TimePicker] = FormTimePicker,
    _a[FormItemTypes.DateTimePicker] = FormDateTimePicker,
    _a[FormItemTypes.CardComponent] = FormCard,
    _a[FormItemTypes.Accordian] = FormAccordion,
    _a[FormItemTypes.MobileStepper] = FormMobileStepper,
    _a[FormItemTypes.Tabs] = FormTabs,
    _a[FormItemTypes.DateRangePicker] = FormDateRangePicker,
    _a[FormItemTypes.Attachment] = FormAttachment,
    _a[FormItemTypes.Box] = function (el) {
        var _el$elements2;
        return /*#__PURE__*/ React.createElement(Box, el, (_el$elements2 = el.elements) === null || _el$elements2 === void 0 ? void 0 : _el$elements2.map(el.formLoop));
    },
    _a[FormItemTypes.ContainerItem] = function (_ref2) {
        var _a = _ref2.columnSize, columnSize = _a === void 0 ? 6 : _a, _b = _ref2.xs, xs = _b === void 0 ? columnSize : _b, _c = _ref2.sm, sm = _c === void 0 ? columnSize : _c, _d = _ref2.md, md = _d === void 0 ? columnSize : _d, _e = _ref2.spacing, spacing = _e === void 0 ? 2 : _e, _f = _ref2.elements, elements = _f === void 0 ? [] : _f, others = _objectWithoutProperties(_ref2, _excluded);
        return /*#__PURE__*/ React.createElement(Grid, _extends({
            container: true,
            item: true,
            xs: xs,
            sm: sm,
            md: md,
            spacing: spacing
        }, others), elements === null || elements === void 0 ? void 0 : elements.map(others.formLoop));
    },
    _a[FormItemTypes.Typography] = function (el) {
        var _el$children;
        return /*#__PURE__*/ React.createElement(Typography, _extends({}, el, {
            children: (_el$children = el.children) !== null && _el$children !== void 0 ? _el$children : el.value
        }));
    },
    _a[FormItemTypes.Button] = FormButton,
    _a[FormItemTypes.IconButton] = FormIconButton,
    _a[FormItemTypes.Divider] = FormDivider,
    _a[FormItemTypes.Avatar] = FormAvatar,
    _a[FormItemTypes.Chip] = FormChip,
    _a[FormItemTypes.Icon] = FormIcon,
    _a[FormItemTypes.SingleSelect] = FormSingleSelect,
    _a[FormItemTypes.Stack] = function (el) {
        var _el$elements3;
        return /*#__PURE__*/ React.createElement(Stack, el, (_el$elements3 = el.elements) === null || _el$elements3 === void 0 ? void 0 : _el$elements3.map(el.formLoop));
    },
    _a[FormItemTypes.List] = FormList,
    _a[FormItemTypes.Iterator] = memo(FormIterator),
    _a[FormItemTypes.ErrorsPanel] = FormErrorsPanel,
    _a[FormItemTypes.Custom] = function (el) {
        var _el$element;
        return el === null || el === void 0 || (_el$element = el.element) === null || _el$element === void 0 ? void 0 : _el$element.call(el, el);
    },
    _a[FormItemTypes.DateRangePickerItem] = function () { return null; },
    _a);
